"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkSubscriptionCreateButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const styled_1 = require("@framework/styled");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const types_1 = require("@framework/types");
const createSubscription_json_1 = __importDefault(require("@framework/abis/json/VRFCoordinatorV2PlusMock/createSubscription.json"));
const ChainLinkSubscriptionCreateButton = props => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { address: account } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const metaFnCreateSub = (0, react_hooks_eth_1.useSystemContract)(async (_values, systemContract) => {
        // https://docs.chain.link/docs/link-token-contracts/
        return writeContractAsync({
            address: systemContract.address,
            abi: createSubscription_json_1.default,
            functionName: "createSubscription",
        });
    });
    const { execute: metaFnCreateSubscription } = (0, react_hooks_eth_1.useMetamask)(() => {
        return metaFnCreateSub(types_1.SystemModuleType.CHAIN_LINK, null);
    });
    const handleCreateSub = () => {
        return metaFnCreateSubscription();
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleCreateSub, icon: icons_material_1.RecentActors, message: "pages.chain-link.create", className: className, dataTestId: "ChainLinkCreateSubscriptionButton", disabled: disabled || !account, buttonSize: "small", variant: variant }));
};
exports.ChainLinkSubscriptionCreateButton = ChainLinkSubscriptionCreateButton;
//# sourceMappingURL=index.js.map